import React, { useState } from 'react';
import { Script } from 'gatsby';

import './HubspotForm.scss';

function HubspotForm({
  formId = 'd930297b-da66-4fc4-a23f-b97b71dc9a06',
  dontUseChiliPiper,
  customChiliPiperRouter = 'inbound-router',
}) {
  const [hubspotScriptLoaded, setHubspotScriptLoaded] = useState(false);
  const [chilipiperScriptLoaded, setChiliPiperScriptLoaded] = useState(false);

  const randomId = formId.split('-')[0];
  const formattedFormId = `hubspotForm-${randomId}`;

  return (
    <>
      {!dontUseChiliPiper && (
        <>
          <Script
            src="https://js.chilipiper.com/marketing.js"
            onLoad={() => setChiliPiperScriptLoaded(true)}
          />
          {chilipiperScriptLoaded && (
            <Script id="chili-piper-config">
              {`
                const cpTenantDomain = "okteto"; // REPLACE and remove square brackets
                const cpRouterName = "${customChiliPiperRouter}"; // REPLACE and remove square brackets
                const cpHubspotFormID = "${formId}"; // REPLACE with a formID or leave empty to run on all forms
                //
                // No changes needed from this point
                //
                // Listen for form submitted message
                window.addEventListener("message", function (event) {
                  if (event.data.type === "hsFormCallback" && event.data.eventName === "onFormSubmit") {
                     if (cpHubspotFormID && event.data.id !== cpHubspotFormID) return
                     var lead = {}; for (var key in event.data.data) { lead[event.data.data[key].name] = event.data.data[key].value; }
                     if(Object.keys(lead).length <= 1){lead = event.data.data;}
                     ChiliPiper.submit(cpTenantDomain, cpRouterName, {
                        map: true,
                        lead: lead
                     });
                  }
                });
              `}
            </Script>
          )}
        </>
      )}
      <Script
        src="https://js.hsforms.net/forms/v2.js"
        onLoad={() => setHubspotScriptLoaded(true)}
      />

      {hubspotScriptLoaded && (
        <Script id={`hubspot-config-${formId}`}>
          {`
            hbspt.forms.create({
              portalId: '5418301',
              formId: '${formId}',
              target: '#${formattedFormId}',
              onFormSubmitted: () => {
                const pancake = document.querySelector(".HubspotFormPancakeCard");
                if(pancake) pancake.scrollIntoView({ behavior: 'smooth'});

                if("${formId}" == "c94bf151-c61e-4380-983d-4ad43c064802") {
                  const gated = document.querySelector(".CalculatorGated");
                  if (gated) gated.classList.remove("CalculatorGated");
                }
              },
              onBeforeFormSubmit: (props) => {
                if("${formId}" == "c94bf151-c61e-4380-983d-4ad43c064802") {
                  const numberOfSoftwareDevs = document.querySelector("[data-roi-number-software-dev]").dataset.roiNumberSoftwareDev;
                  const salaryOfSoftwareDevs = document.querySelector("[data-roi-salary-software-dev]").dataset.roiSalarySoftwareDev
                  const numberOfPlatformDevs = document.querySelector("[data-roi-number-platform-dev]").dataset.roiNumberPlatformDev;
                  const salaryOfPlatformDevs = document.querySelector("[data-roi-salary-platform-dev]").dataset.roiSalaryPlatformDev;
                  const gainsResults = document.querySelector("[data-roi-savings]").dataset.roiSavings;
                  document.querySelector("[name='roi_number_devs']").value = numberOfSoftwareDevs;
                  document.querySelector("[name='roi_salary_devs']").value = salaryOfSoftwareDevs;
                  document.querySelector("[name='roi_number_platform']").value = numberOfPlatformDevs;
                  document.querySelector("[name='roi_salary_platform']").value = salaryOfPlatformDevs;
                  document.querySelector("[name='roi_gains_results']").value = gainsResults;
                }
              }
            })
          `}
        </Script>
      )}

      {formId === 'e0bcc9fa-44f2-4d25-a0ba-99273f0207b9' && (
        <Script>
          {`
            window.addEventListener("message", ({data}) => {
              if (data.type === "hsFormCallback" && data.eventName === "onFormSubmit" && data.id === "e0bcc9fa-44f2-4d25-a0ba-99273f0207b9") {
                const formData = data.data
                fetch('/.netlify/functions/free-trial', {
                  method: 'POST',
                  body: JSON.stringify({
                    formData
                  })
                })
              }
            })
            `}
        </Script>
      )}

      <div className="HubspotForm" id={formattedFormId}></div>
    </>
  );
}

export default HubspotForm;
